module.exports = __webpack_public_path__ + "static/assets/53abdcf3925c1f3448c8385c48104362.png";